import Vue from 'vue'
import ls from 'local-storage'
import { get, set } from 'lodash'

export default () => {
  Vue.mixin({
    created () {
      if(this.persist) {
        const persistId = this.persistId || this.$options.name

        this.persistWatchers = []
        this.persist.forEach(name => {
          const value = ls.get('component-persist:' + persistId + ':' + name)
          if(value !== null) set(this, name, value)

          this.persistWatchers.push(this.$watch(name, () => {
            const value = get(this, name)
            if(value !== undefined) {
              console.log('component-persist:' + persistId + ':' + name, value)
              ls.set('component-persist:' + persistId + ':' + name, value)
            }
          }, {
            deep: true
          }))
        })
      }
    },
    destroyed () {
      if(this.persistWatchers) {
        this.persistWatchers.forEach(unwatch => unwatch())
      }
    }
  })

  return ls
}